import { Injectable } from '@angular/core';

@Injectable()
export class BlobService {
  public save(blob: Blob, filename: string): void {

    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(blob, filename);
      return;
    }

    const a = document.createElement('a');
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.type = blob.type;
    a.hidden = true;
    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/blob.service.ts